import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatIcon } from '@angular/material/icon';
import { MatMenuItem } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { RouteUtilsService } from '@lassi/webapp-shared';
import { map, switchMap } from 'rxjs';
import { NavButtonItem } from './nav-button-base';

@Component({
  selector: 'lassi-nav-menu-button',
  imports: [CommonModule, MatIcon, RouterModule, MatMenuItem],
  template: `
    <button
      mat-menu-item
      [attr.data-testid]="item().id"
      [routerLink]="routerLink()"
      queryParamsHandling="merge"
      [class.active]="isActive()"
      [info]="{
        restore: true,
      }"
    >
      @if (item().isSvgIcon) {
        <mat-icon class="centered-svg-icon" [svgIcon]="item().icon" />
      } @else {
        <mat-icon>{{ item().icon }}</mat-icon>
      }
      <span>{{ item().label }}</span>
    </button>
  `,
  styles: `
    @use 'navbar' as *;
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavMenuButtonComponent {
  item = input.required<NavButtonItem>();

  private readonly routeUtils = inject(RouteUtilsService);

  isActive$ = toObservable(this.item).pipe(
    map((item) => item.name),
    switchMap((path) =>
      this.routeUtils
        .isDrawerPageActive(path.split('/'))
        .pipe(map((isActive) => ({ isActive, path }))),
    ),
  );

  isActive = toSignal(this.isActive$.pipe(map(({ isActive }) => isActive)));

  routerLink = toSignal(
    this.isActive$.pipe(
      map(({ isActive, path }) =>
        isActive
          ? ['.']
          : [
              {
                outlets: {
                  [RouteUtilsService.MAP_MENU_OUTLET_NAME]: [
                    RouteUtilsService.MAP_MENU_ROOT_PATH,
                    ...path.split('/'),
                  ],
                },
              },
            ],
      ),
    ),
  );
}
